export default function SubtitleBlock(props) {
  const simpleBlock = props.props ?? props.pageBlock;
  return (

      <h2 className="text-blue-500 font-bold tracking-tighter text-3xl md:text-5xl mb-0 pb-2 leading-none max-w-6xl mx-4 xl:mx-auto border-b-solid border-b-4 md:border-b-8 border-blue-500">
        {simpleBlock.subtitle}
      </h2>
  );
}
